import { render, staticRenderFns } from "./DevTab.vue?vue&type=template&id=04bfdcfa&scoped=true&"
import script from "./DevTab.vue?vue&type=script&lang=js&"
export * from "./DevTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bfdcfa",
  null
  
)

export default component.exports